<template>
  <el-dialog
    class="my-dialog"
    title="添加文档"
    :visible.sync="dialogVisible"
    width="50%"
    @close="clickCancel"
  >
    <div class="docDialog-content">
      <el-form inline>
        <el-form-item label="文档名称:">
          <el-input v-model="docName" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary" @click="onFilter">筛选</el-button>
        </el-form-item>
      </el-form>
      <div class="tips-box" v-if="multipleSelection.length">
        <span class="tips-text">已选{{ multipleSelection.length }}项</span>
      </div>
      <el-table
        ref="table"
        v-loading="isLoading"
        class="my-table"
        :data="dataList"
        highlight-current-row
        :row-key="getRowKey"
        @selection-change="handleSelectionChange"
        @select="handleSelect"
      >
        <template slot="empty">
          <!-- 没有数据 -->
          <NoData></NoData>
        </template>
        <el-table-column
          type="selection"
          width="55"
          reserve-selection
          :selectable="isSelectable"
        ></el-table-column>
        <el-table-column property="name" label="文档名称">
          <template #default="{ row }">
            <div class="table-item-content">
              <img :src="mapDocType(row)" alt="" class="doc_type_icon" />
              <span class="title" :title="row.name">
                {{ row.name }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="Size" label="文档大小">
          <template #default="{ row }">
            <div>
              {{ bytesToSize(row.size) }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        :current-page.sync="pagination.page_index"
        :page-size="pagination.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="g_pageSizesConfig"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="clickCancel">取 消</el-button>
      <el-button type="primary" @click="clickConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import NoData from '@/components/no-data';
import { arrUnique, bytesToSize } from '@/utils/util';
import { GetDocList } from '@/api/releaseManagement';
import { IMG_SRC } from '@/utils/constant';
const { docTypeImg } = IMG_SRC;
export default {
  name: 'DocDialog',
  components: {
    NoData,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    labelDoc: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      bytesToSize,
      docName: '',
      pagination: {
        page_size: this.g_pageSizeDefault,
        page_index: 1,
      },
      dataList: [],
      total: 0,
      isLoading: false,
      multipleSelection: [],
      totalDoc: [],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  async created() {
    this.pagination.page_size = this.g_pageSizeDefault;
    await this.getList();
    this.totalDoc = await arrUnique([...this.multipleSelection, ...this.labelDoc], 'id');
  },
  methods: {
    isSelectable(row) {
      const IdsArr = this.totalDoc.map((row) => row.id);
      if (IdsArr.length && IdsArr.length >= 10 && !IdsArr.some((id) => id === row.id)) {
        return false;
      }

      return true;
    },
    getRowKey(row) {
      return row.id;
    },
    mapDocType(row) {
      return docTypeImg[row.documentType] || docTypeImg.default;
    },
    handleSelect(selection, row) {
      if (selection.findIndex((sel) => sel.id === row.id) === -1) {
        const i = this.totalDoc.findIndex((doc) => doc.id === row.id);
        this.totalDoc.splice(i, 1);
      } else {
        this.totalDoc.push(row);
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;

      if (this.totalDoc.length >= 10) {
        this.$message.warning('已达10个文档上限');
      }
    },
    onFilter() {
      this.pagination.page_index = 1;
      this.getList();
    },
    async getList() {
      this.isLoading = true;
      try {
        const res = await GetDocList({
          Name: this.docName,
          Req: {
            PageIndex: this.pagination.page_index,
            PageSize: this.pagination.page_size,
            OrderBy: '-CTime',
          },
        });
        this.dataList = res.Records.map((item) => ({
          id: item.Id,
          name: item.Name,
          documentType: item.Type,
          size: item.Size,
        }));
        this.total = res.Total;

        const IdsArr = this.labelDoc.map((item) => item.id);
        if (IdsArr.length) {
          this.$nextTick(() => {
            this.dataList.forEach((row) => {
              if (IdsArr.some((id) => id === row.id)) {
                this.$refs.table.toggleRowSelection(row, true);
              }
            });
          });
        }
        this.isLoading = false;
      } catch (err) {
        console.log('err', err);
        this.isLoading = false;
      }
    },
    handleCurrentChange(val) {
      this.pagination.page_index = val;
      this.getList();
    },
    handleSizeChange(size) {
      this.pagination.page_size = size;
      this.getList();
    },
    clickCancel() {
      this.$emit('clickCancel');
    },
    clickConfirm() {
      console.log('confirm', this.totalDoc);
      this.$emit('clickConfirm', [...this.totalDoc]);
    },
  },
};
</script>

<style lang="scss" scoped>
.my-dialog ::v-deep.el-dialog {
  .el-dialog__footer {
    margin-top: 20px;
    text-align: center;
  }
}
.docDialog-content {
  .doc_type_icon {
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align: middle;
  }
  .tips-box {
    background: rgba(47, 150, 255, 0.1);
    border: 1px solid #2f96ff;
    height: 36px;
    line-height: 36px;
    padding-left: 30px;
    .tips-text {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #313233;
    }
  }
  .pagination {
    float: right;
    margin-top: 12px;
  }
}
.el-table ::v-deep.el-table__header-wrapper .el-table__header .el-checkbox__input {
  // 禁用表头的多选框
  display: none;
}
</style>
